export default {
}

// 0 - employee
// 1 - branch
// 2 - organisation admin
// 3 - we
